import React, { useRef } from 'react'
import { Card, Button } from 'react-bootstrap'
import { useIntersection } from 'react-use'
import doctor from '../../images/doctor.png'
import emaJhon from '../../images/emajhon.png'
import burj from '../../images/burj.png'
import gym from '../../images/gym.png'
import proShop from '../../images/proshop.png'
import letsTalk from '../../images/letschat.png'
import covid from '../../images/covid.png'
import LanguageIcon from '@material-ui/icons/Language'
import GitHubIcon from '@material-ui/icons/GitHub'
import './project.scss'
import gsap from 'gsap'
import { Link } from 'react-router-dom'

const Projects = () => {
  const sectionRef = useRef(null)

  const intersection = useIntersection(sectionRef, {
    root: null,
    rootMargin: '0px',
    threshold: 0.1,
  })

  const fadeIn = (element) => {
    gsap.to(element, 1, {
      opacity: 1,
      y: -60,
      ease: 'power4.out',
      stagger: {
        amount: 0.3,
      },
    })
  }
  const fadeOut = (element) => {
    gsap.to(element, 1, {
      opacity: 0,
      y: -20,
      ease: 'power4.out',
    })
  }

  intersection && intersection.intersectionRatio < 0.1
    ? fadeOut('.fadeIn')
    : fadeIn('.fadeIn')

  const doneProjects = [
    {
      title: 'ProShopBD',
      img: proShop,
      link: 'https://proshopbd.herokuapp.com',
      gitLink: 'https://github.com/irtiza1999/ProShopBd',
      description:
        'ProShopBD is a complete website with both user and admin panel. Users can buy products and the admins can add products, manage all products, users. Technologies used in this projects are ReactJS, NodeJS, ExpressJS, MongoDB, Heroku.',
    },
    {
      title: "Let's Talk Messages",
      img: letsTalk,
      link: 'https://let-s-talk-ishad.web.app',
      gitLink: 'https://github.com/irtiza1999/Lets-Talk',
      description:
        'Lets-Talk is a real time messaging app. Where users can sign in with google and send messages to separate rooms and also create room.. Technologies used in this projects are ReactJS, NodeJS, ExpressJS, Firebase.',
    },
    {
      title: 'Covid-19 Update',
      img: covid,
      link: 'https://covid-19-updateslive.netlify.app',
      gitLink: 'https://github.com/irtiza1999/Covid-19-Update',
      description:
        'Covid-19 updates gives live covid-19 statistics based of total affected people, recovered people and total deaths. Technologies used in this projects are ReactJS.',
    },
    {
      title: 'Doctor portal',
      img: doctor,
      link: 'https://doctors-portal-ishad.web.app',
      gitLink: 'https://github.com/irtiza1999/Doctor-Portal',
      description:
        'Doctor portal is a complete website with both user and admin panel. Users can book, see and manage their appointments and the admins can add doctor, manage all appointments. Technologies used in this projects are ReactJS, NodeJS, ExpressJS, MongoDB, Firebase.',
    },
    {
      title: 'Power X Gym',
      img: gym,
      link: 'https://powerxgymishad.netlify.app',
      gitLink: 'https://github.com/irtiza1999/Power-X-Gym',
      description:
        'Power X Gym is a simple gymnasium site where user can get their health plan and purchase it with payment gateway. Technologies used in this projects are ReactJS, NodeJS, ExpressJS, MongoDB, Heroku.',
    },
    {
      title: 'Ema John',
      img: emaJhon,
      link: 'https://ema-john-simple-ishad.web.app/',
      gitLink: 'https://github.com/irtiza1999/Ema-John-Simple',
      description:
        'Ema Jhon is a simple e-commerce site with payment gateway and admin panel. Technologies used in this projects are ReactJS, NodeJS, ExpressJS, MongoDB, Firebase, Heroku.',
    },
  ]

  return (
    <div>
      <h1
        data-aos="fade-up"
        data-aos-easing="ease-in-sine"
        style={{ textAlign: 'center', padding: '50px', color: '#006ADC' }}
      >
        PROJECTS
      </h1>
      <div
        id="projects"
        ref={sectionRef}
        className="row justify-content-around"
      >
        {doneProjects.map((project) => (
          <div
            key={project.title}
            className="fadeIn col-md-4 col-sm-12"
            data-aos="fade-up"
            data-aos-easing="ease-in"
          >
            <div className="record_wrap">
              <a
                style={{ color: '#666', textDecoration: 'none' }}
                href={project.link}
                target="_blank"
                rel="noreferrer"
                className="pName"
              >
                <h3>{project.title}</h3>
              </a>

              <hr />
              <section className=" record">
                <div
                  className="record-arrow"
                  style={{ backgroundImage: 'url(' + project.img + ')' }}
                ></div>
                <div
                  id="record1"
                  className="record-display"
                  style={{ backgroundImage: 'url(' + project.img + ')' }}
                ></div>
                <div className="record-desc">
                  <h5 style={{ color: '#666' }}>{project.description}</h5>
                  <div className="icon row justify-content-around">
                    {project.link !== ' ' ? (
                      <a href={project.link} target="_blank" rel="noreferrer">
                        <LanguageIcon /> <br /> <span>Live website</span>
                      </a>
                    ) : (
                      <Link to="/maintanence" target="_blank">
                        <LanguageIcon /> <br /> <span>Live website</span>
                      </Link>
                    )}

                    <a href={project.gitLink} target="_blank" rel="noreferrer">
                      <GitHubIcon /> <br /> <span>Github repository</span>
                    </a>
                  </div>
                </div>
              </section>
            </div>
          </div>
        ))}
        <div
          data-aos="fade-up"
          data-aos-easing="ease-in-sine"
          style={{
            textAlign: 'center',
            marginTop: '-50px',
            marginBottom: '20px',
          }}
        >
          <h3>
            Many other neetworthy projects can be found in my{' '}
            <a
              href="https://github.com/irtiza1999"
              target="_blank"
              rel="noreferrer"
              style={{ textDecoration: 'none' }}
            >
              <GitHubIcon /> <br /> <span>Github repository.</span>{' '}
            </a>
          </h3>
        </div>
      </div>
    </div>
  )
}
export default Projects
